import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditDirectionText() {
  return <div className="space-y-6 max-w-3xl mx-auto" data-id="element-209">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-210">Edit Direction Text</h1>

      <Card data-id="element-211">
        <CardContent className="space-y-6 pt-6" data-id="element-212">
          <Input label="Title" placeholder="Enter title..." data-id="element-213" />

          <div className="space-y-1" data-id="element-214">
            <label className="block text-sm font-medium text-slate-700" data-id="element-215">
              Body
            </label>
            <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-216">
              <div className="bg-slate-50 border-b border-slate-300 p-2 flex gap-2" data-id="element-217">
                <button className="p-1 hover:bg-slate-200 rounded font-bold text-xs" data-id="element-218">
                  B
                </button>
                <button className="p-1 hover:bg-slate-200 rounded italic text-xs" data-id="element-219">
                  I
                </button>
                <button className="p-1 hover:bg-slate-200 rounded underline text-xs" data-id="element-220">
                  U
                </button>
                <div className="w-px h-4 bg-slate-300 mx-1 self-center" data-id="element-221"></div>
                <button className="p-1 hover:bg-slate-200 rounded text-xs" data-id="element-222">
                  Link
                </button>
                <button className="p-1 hover:bg-slate-200 rounded text-xs" data-id="element-223">
                  Image
                </button>
              </div>
              <textarea className="w-full min-h-[300px] p-4 text-sm focus:outline-none" placeholder="Enter rich text content..." data-id="element-224" />
            </div>
          </div>

          <div className="pt-4" data-id="element-225">
            <Button data-id="element-226">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}